import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from './Common';

// handle the public routes
function PublicRoute({ children }) {
  const token = getToken();
  
  return !token ? children : <Navigate to="/dashboard" replace />;
}

export default PublicRoute;